(function () {
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    if (!section) {
        console.warn(`Section with ID ${sectionID} not found.`);
        return;
    }

    // collect bundle items (one per product block)
    const items = Array.from(section.querySelectorAll(".kitV1ItemJSON")).map(el => {
        const product = JSON.parse(el.textContent);
        const variant = product.variants[0];
        const sellingPlanID = variant.selling_plan_allocations?.[0]?.selling_plan_id;
        return { variant, sellingPlanID };
    }).reverse();

    const soldOut = items.some(item => !item.variant.available);
    const atcBtn = section.querySelector(".kitV1ATC");
    if (soldOut) {
        atcBtn.disabled = true;
        atcBtn.style.pointerEvents = "none";
        atcBtn.textContent = "Sold Out";
    }

    // image swiper
    new Swiper(section.querySelector(".kitV1Swiper"), {
        slidesPerView: 1,
        spaceBetween: 0,
        observer: true,
        observeParents: true,
        observeSlideChildren: true,
        pagination: {
            el: section.querySelector(".kitV1SwiperPagination"),
            clickable: true,
        },
    });

    // faq toggle
    section.querySelectorAll(".kitV1FaqTop").forEach(el => {
        const parent = el.closest(".kitV1Faq");
        el.addEventListener("click", function () {
            this.classList.toggle("active");
            parent.querySelector(".kitV1FaqBottom").classList.toggle("active");
        });
    });

    // add to cart
    section.querySelector(".kitV1ATC").addEventListener("click", async function () {
        if (!items.length) return;
        this.classList.add("loading");

        try {
            await addProduct({
                items: items.map(item => {
                    const line = { id: item.variant.id, quantity: 1 };
                    if (item.sellingPlanID) line.selling_plan = item.sellingPlanID;
                    return line;
                })
            });
            window.location.href = "/checkout";
            return;
        } catch (err) {
            console.error("Kit ATC failed:", err.status, err.body ?? err.message);
        }

        this.classList.remove("loading");
    });

    // smooth scroll for anchor buttons
    document.addEventListener("DOMContentLoaded", function () {
        document.querySelectorAll(`.button[href="#"]`).forEach(button => button.addEventListener("click", function (event) {
            event.preventDefault();
            section.querySelector(".kitV1Content").scrollIntoView({ behavior: "smooth", block: "start" });
        }));
    });
}());
